<template>
  <MultiSelect
    v-model="model"
    :options="options"
    taggable
    placeholder="Add tags"
  />
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";
import MultiSelect from "./MultiSelect.vue";

const props = defineProps<{
  modelValue: string[];
  userId: string;
  tagListUrl?: string;
}>();
const emit = defineEmits<{ "update:modelValue": [string[]] }>();

const model = computed({
  get: () => props.modelValue,
  set: (v: string[]) => emit("update:modelValue", v),
});

const options = ref<{ label: string; value: string }[]>([]);

onMounted(async () => {
  try {
    const tags: { tag: string; count: number }[] = await fetch(
      props.tagListUrl || "/api/tag/list",
      { credentials: "include" }
    ).then((r) => r.json());
    options.value = tags.map((t) => ({
      value: t.tag,
      label: `${t.tag} (${t.count})`,
    }));
  } catch (err) {
    console.error("Failed to load tag list", err);
  }
});
</script>
